module.exports = __webpack_public_path__ + "img/medical_mingxing.fe40822b.png";